import { createTheme, Theme, ThemeProvider } from '@mui/material'
import { merge } from 'lodash'
import { useEffect, useState } from 'react'

import theme from '~/app/providers/ui/theme'
import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { TBrandColor } from '~/features/partners/models'
import {
  convertBrandColorsToPaletteObject,
  isArrayOfTypeTBrandColor,
} from '~/features/partners/utils'

function PartnerThemeWrapper({ children }: { children: React.ReactNode }) {
  const { partner, isLoading } = usePartnerCentralized()

  const [updatedTheme, setUpdatedTheme] = useState<Theme | undefined>()

  useEffect(() => {
    if (isArrayOfTypeTBrandColor(partner.brandUIColors)) {
      const customColors = convertBrandColorsToPaletteObject(
        partner.brandUIColors as TBrandColor[],
      )

      setUpdatedTheme(
        createTheme(
          merge({ ...theme, palette: { ...theme.palette } }, customColors),
        ),
      )
    }
  }, [partner.brandUIColors])

  if (!updatedTheme || (!partner.brandUIColors && isLoading)) {
    return <LoadingWithBackdrop show />
  }

  return <ThemeProvider theme={updatedTheme}>{children}</ThemeProvider>
}
export default PartnerThemeWrapper
